export const NOTE_TEMPLATES_PATH = "/settings/note_templates";

export const NOTE_TEMPLATE_TABLE_CONSTANTS = {
  tableName: "note_templates",
  queryKey: "note_templates",
  className: "NoteTemplate",
  exportTableName: null,
  header: "Note Templates",
};
